module.exports = __webpack_public_path__ + "static/img/guanlihoutai.175ac18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/guanlihoutai.png
// module id = oW2J
// module chunks = 0